<template>
  <v-layout row wrap pa-5>
    <v-flex xs12 md12>
      <v-layout row wrap>
        <v-flex xs12 md12 SearchC>
          <Search 
            :loading="loading"
            :resourceSettings="resourceSettings" 
            :time="time"
            @searchResource="searchResource" 
            @loadResource="reLoadResource"
            @create="createNewProduct()"
            @createCategory="()=>{newCategory = {}; dialogCategory = true;}"
            @viewCategories="viewCategories"
          />
        </v-flex>
        <v-flex xs12 md12 SearchC style="min-height:35px;">
          <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex xs12 md12 Filters>
          <!-- <Filters 
            :loading="loading"
            :resourceSettings="resourceSettings" 
            :resource="resource"
            :time="time"
            @filterResource="filterResource"
          /> -->
        </v-flex>
        <v-flex xs12 md12 class="text-xs-center" PagingC>
          <Paging 
            :resourceSettings="resourceSettings" 
            :resource="resource"
            @loadResource="loadResource"
            @pageByNumber="pageByNumber"
          />
        </v-flex>
        <v-flex xs12 md12 Details>
          <listPanel
            :resource="resource"
            :resourceSettings="resourceSettings"
            @copyS="clipboardSuccessHandler"
            @copyF="clipboardErrorHandler"
            @editResource="editResource"
            :loading="loading"
            :resourceKeys="resourceKeys"
          />
        </v-flex>
        <v-flex xs12 md12 class="text-xs-center" PagingC>
          <Paging 
            :resourceSettings="resourceSettings" 
            :resource="resource"
            @loadResource="loadResource"
            @pageByNumber="pageByNumber"
          />
        </v-flex>
        <multiDialog
          :dialog="dialog"
          :loading="loading"
          :resourceSettings="resourceSettings"
          :deleting="deleting"
          :resourceKeys="resourceKeys"
          :newResource="newResource"
          :resource="resource"
          @closeDialog="()=>{ dialog = false; newResource = { prices:[], images:[], variants:[], vendorsubs:[] }; }"
          @deleteResource="deleteResource"
          @updateResource="updateResource"
          @postResource="postResource"
          @upload="getUpload"
          @snackbarNotification="emitsnackbarNotification"
        />
        <catDialog
          :dialog="dialogCategory"
          :loading="loading"
          :newResource="newCategory"
          :resourceSettings="{resourceName:'categories'}"
          :resourceKeys="categoryKeys"
          :resource="resource.categories"
          @closeDialog="()=>{ dialogCategory = false; newCategory = {}; }"
          @updateResource="updateCategory"
          @postResource="postCategory"
        />
        <catsDialog
          :loading="loading"
          :resource="resource.categories"
          :dialog="dialogViewCategory"
          @editCategory="editCategory"
          @closeDialog="()=>{ dialogViewCategory = false; newCategory = {}; }"
        />
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import Search from '@/components/Search'
import Paging from '@/components/Paging'
import multiDialog from '@/components/multiDialog'
import catDialog from '@/components/catDialog'
import catsDialog from '@/components/catsDialog'
import listPanel from '@/components/listPanel'
import Filters from '@/components/Filters'
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';
import { format, render, cancel, register } from 'timeago.js';
import {firebase, store, db, auth, storageRef } from '@/fb';
import axios from 'axios';
import { productApiUrl } from '@/config/urls';
const headers = {'Accept': 'application/json'};

export default {
  components: { Search, Paging, multiDialog, listPanel, Filters, catDialog, catsDialog },
  data() {
    return {
      loading:false,
      dialog:false,
      dialogCategory:false,
      dialogViewCategory:false,
      vresource:[],
      resource:[],
      search:null,
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      resourceKeys:[
        { name: 'sku', label: 'sku', type: 'text', fetched: 'sku', required: true, max:8, disabled:true, info:{en: 'unique sku'}},
        { name: 'item_name', label: 'item_name', type: 'text', fetched: 'item_name', required: true, info:{en: 'internal name'}},
        { name: 'name_en', label: 'name_en', type: 'text', fetched: 'name_en', required: true, info:{en: 'external EN name'}},
        { name: 'name_ar', label: 'name_ar', type: 'text', fetched: 'name_ar', required: true, info:{en: 'external AR name'}},
        { name: 'active', label: 'Product Active on CRM', type: 'switch', fetched: 'active'},
        { name: 'web', label: 'Product Active on Web', type: 'switch', fetched: 'web'},
        { name: 'categories_id', label: 'categories', type: 'select', items:'categories', multiple:true, fetched: 'categories_id', data:[], source:'db', info:{en: 'web category'}},
        { name: 'description_web_en', label: 'description_web_en', type: 'textarea', fetched: 'description_web_en', info:{en: 'web EN description'}},
        { name: 'description_web_ar', label: 'description_web_ar', type: 'textarea', fetched: 'description_web_ar', info:{en: 'web EN description'}},
        { name: 'youtube', label: 'Youtube', type: 'text', fetched: 'youtube', required: false, info:{en: 'YouTube Link'}},
        { name: 'description_en', label: 'description_en', type: 'editor', fetched: 'description_en', info:{en: 'external EN description'}},
        { name: 'description_ar', label: 'description_ar', type: 'editor', fetched: 'description_ar', info:{en: 'external AR description'}},
        { name: 'note', label: 'note', type: 'editor', fetched: 'note', info:{en: 'Note for Agent'}},
      ],
      categoryKeys:[
        { name: 'name', label: 'name', type: 'text', fetched: 'name', required: true, info:{en: 'internal name'}},
      ],
      resourceSettings:{
        resourceName:null,
        search:true,
        pagination:true,
        create:true,
      },
      newResource:{prices:[], images:[], vprices:[], accounts:[], variants:[], vendorsubs:[]},
      newCategory:{},
      editing:false,
      deleting:false,
      filter:'',
      time:0,
      page:1,
      warehouses:[],
    }
  },
  
  methods: {
    async createNewProduct(){
      this.newResource = {prices:[], images:[], variants:[], vendorsubs:[]}; 
      let sku = await axios.get('https://us-central1-ashyaatcrm.cloudfunctions.net/gensku/genSKU/ninja').then(x=>x.data.next_sku)
      this.newResource.sku = `A.00${sku}`
      this.dialog = true;
    },
    getUpload(o){
      this.newResource[o.field] = o.value
    },
    editResource(r){
      this.dialog = true
      this.editing = true
      this.newResource = r
    },
    emitsnackbarNotification(a, b){
      this.$emit('snackbarNotification', a, b)

    },
    clipboardSuccessHandler (){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler () {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    async loadItems(){
      return new Promise(async (res, rej)=>{
        let ks = this.resourceKeys.filter(x=>x.type=='select' && x.source == 'db');
        (async x=> {
          for (let i = 0; i < ks.length; i++) {
            const f = ks[i];
            let t = this.resource[f.items]
            let maps = t.map(x=>{
              let t = x.name?x.name:null
              return{...x, text:t, [`${f.name}_id`]:x.id}
            })
            f.data = maps
          }
          res(true)
        })()
      })
    },
    superA(){
      return this.$store.state.user && this.$store.state.user.role == 'superadmin'
    },
    getFormat(d){
      return format(d)
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode != 45 && charCode != 46 &&
      !(charCode >= 48 && charCode <= 57)) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    async filterResource(filter){
      this.filter = filter
      this.page = 1
      await this.loadResource()
    },
    async reLoadResource(){
      this.search = null
      await this.loadResource()
    },
    async loadResource() {
      return new Promise(async (res, rej)=>{
        let start = new Date().getTime()
        this.loading = true
        console.log(this.search)
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:this.$route.path + `?page=${this.page}` + this.filter})
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + '/search', value:this.search})
        }
        let end = new Date().getTime()
        this.time = ((end - start) / 1000).toFixed(1)
        this.loading = false
        res()
      })
    },
    async pageByNumber(n){
      return new Promise(async (res, rej)=>{
        this.loading = true
        let start = new Date().getTime()
        this.page = n
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:this.$route.path, page:`?page=${n}` + this.filter})
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + `/search?page=${n}`, value:this.search})
        }
        let end = new Date().getTime()
        this.time = ((end - start) / 1000).toFixed(1)
        this.loading = false
      })
    },
    async searchResource(search){
      return new Promise(async (res, rej)=>{
        this.search = search
        this.loading = true
        this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + '/search', value:this.search})
        this.loading = false
      })
    },
    async getWarehouses(){
      return new Promise(async (res, rej)=>{
        this.loading = true
        let a = await store.collection('warehouses').get().then(x=>x.docs.map(y=>y.data()))
        this.warehouses = a.map(x=>{
          return {
            quantity:0,
            warehouse:x.name
          }
        })
        console.log(this.warehouses)
        res(true)
      })
    },
    async postToProductsFirebase(r) {
      return new Promise(async (res, rej)=>{
        let {
          active,
          description_ar,
          description_en,
          item_name,
          key,
          name_ar,
          name_en,
          sku,
          note,
        } = r
        let p = {
          active,
          description_ar,
          description_en,
          item_name,
          key,
          name_ar,
          name_en,
          sku,
          note,
        }
        if(r.id) {
          p.id = r.id
        }
        p.img = r.image && r.image.url ? r.image.url : ''
        p.prices = r.prices.map(c=>{return{country:c.name, ...c}})
        console.log('r', r)

        let ps = [ p, ...r.variants.map(x=>{
          return {
            active:r.active,
            img: r.image && r.image.url ? r.image.url : '',
            prices: r.prices.map(c=>{return{country:c.name, ...c}}), 
            description_ar:r.description_ar,
            description_en: r.description_en,
            item_name:x.name,
            note:r.note,
            key:x.key,
            sku:x.sku,
            name_ar:x.name_ar,
            name_en:x.name_en,
            id:x.id,
          }
        }), ...r.vendorsubs.map(x=>{
          return {
            active:r.active,
            img: r.image && r.image.url ? r.image.url : '',
            prices: r.prices.map(c=>{return{country:c.name, ...c}}), 
            description_ar:r.description_ar,
            description_en: r.description_en,
            item_name:r.item_name,
            note:r.note,
            sku:x.sku,
            key:x.key,
            name_ar:r.name_ar,
            name_en:r.name_en,
            id:x.id,
            account_id:x.account_id
          }
        })
        ];
        console.log(ps)

        for (let i = 0; i < ps.length; i++) {
          const dbi = ps[i];
          let dbp = {}
          for (const key in dbi) {
            if (Object.hasOwnProperty.call(dbi, key)) {
              const val = dbi[key];
              if(val) {
                dbp[key] = val
              }
            }
          }
          console.log(dbp)
          if(!dbp.key) {
            let products = await store.collection("products")
            .where("sku", "==", dbp.sku).get()
            .then(x=>x.docs.map(y=>{
              return {
                ...y.data(),
                alternatives: y.data().alternatives ? y.data().alternatives:[],
                warehouses:y.data().warehouses? y.data().warehouses:[],
                key:y.id
              }
            }));
            let exists = products.length && products[0] && products[0].key
            dbp.key = exists ? products[0].key : null
            dbp.exists = exists
          }

          if((dbp.key && dbp.id) || dbp.exists) {
            let pin = await db.ref(`productsCore/${dbp.key}`).once('value').then(x=>x.val())
            console.log(pin)
            await db.ref(`productsCore/${dbp.key}`).update(dbp)
            await db.ref(`products/${dbp.key}`).update(dbp)
            await db.ref(`productsCoreLite/${dbp.key}`).update(dbp)
            this.$emit('snackbarNotification', `SKU SYNC`, 'success')
          } else {
            
            let bb = await db.ref('uKeys').push()
            dbp.key = bb.key
            await db.ref(`productsCore/${dbp.key}`).update(dbp)
            await db.ref(`products/${dbp.key}`).update(dbp)
            await db.ref(`productsCoreLite/${dbp.key}`).update(dbp)
            let wn = {
              item_name:dbp.item_name,
              key:dbp.key,
              sku:dbp.sku,
              warehouses:this.warehouses
            }
            console.log(wn)
            await store.collection(`products`).doc(dbp.key).set(wn)
            await store.collection(`productsLive`).doc(dbp.key).set(wn)
            await db.ref('uKeys').update({
              [bb.key]:null
            })
          }
        }
        res(true)
      })
    },
    async updateResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        r.categories = r.categories_id
        console.log('product', r)
        await this.$store.dispatch('putResource', {resource:this.$route.path + `/${r.id}`, value:r})
        await this.postToProductsFirebase(r)
        this.dialog = false
        this.editing = false
        this.loading = false
        await this.loadResource()
        this.newResource = {prices:[], images:[], variants:[], vprices:[], accounts:[], vendorsubs:[]}
      })
    },
    async deleteResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        await this.$store.dispatch('deleteResource', {resource:this.$route.path + `/${r.id}`})
        this.dialog = false
        this.deleting = false
        this.loading = false
        await this.loadResource()
        this.newResource = {prices:[], images:[], variants:[], vprices:[], accounts:[], vendorsubs:[]}
      })
    },
    async postResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        console.log(JSON.stringify(r))
        let bb = await db.ref('uKeys').push()
        r.key = bb.key
        console.log('product', r)
        await this.$store.dispatch('postResource', {resource:this.$route.path + `${r.id ? '/' + r.id : ''}`, value:r})
        await this.postToProductsFirebase(r)
        this.dialog = false
        this.loading = false
        await db.ref('uKeys').update({
          [bb.key]:null
        })
        await this.loadResource()
        this.newResource = {prices:[], images:[], variants:[], vprices:[], accounts:[], vendorsubs:[]}
      })
    },
    setResourceName(){
      this.resourceSettings.resourceName = this.$route.path.replace('/', '')
    },
    async postCustomResource(path, r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        console.log(JSON.stringify(r))
        await this.$store.dispatch('postResource', {resource:path + `${r.id ? '/' + r.id : ''}`, value:r})
        this.dialog = false
        this.loading = false
        this.newCategory = {}
        res()
      })
    },
    async updateCustomResource(path,r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        await this.$store.dispatch('putResource', {resource:path + `/${r.id}`, value:r})
        this.dialog = false
        this.editing = false
        this.loading = false
        this.newCategory = {}
        res()
      })
    },
    async updateCategory(r){
      await this.updateCustomResource('/categories', r)
      this.dialogViewCategory = false
      this.dialogCategory = false
      await this.loadResource()

    },
    async postCategory(r){
      await this.postCustomResource('/categories', r)
      this.dialogViewCategory = false
      this.dialogCategory = false
      await this.loadResource()
    },
    viewCategories(){
      this.dialogViewCategory = true
    },
    editCategory(r){
      this.newCategory = r
      this.dialogCategory = true
    },
    async deleteExtraKeys(){
      let a = await db.ref(`productsCore`).once('value').then(x=>x.val())
      let b = await db.ref(`products`).once('value').then(x=>x.val())
      let c = await db.ref(`productsCoreLite`).once('value').then(x=>x.val())
      let d = await store.collection('products').get()
          .then(x=>x.docs.map(y=>{
            return {
              ...y.data(),
              warehouses:y.data().warehouses? y.data().warehouses:[]
            }
          }))
      let e = await store.collection('productsLive').get()
          .then(x=>x.docs.map(y=>{
            return {
              ...y.data(),
              warehouses:y.data().warehouses? y.data().warehouses:[]
            }
          }))
      let f = await axios.get(productApiUrl('products-all'))
      let fkeys = f.data.map(x=>x.key)
      let dfilterd = d.filter(x=>!fkeys.includes(x.key))
      let efilterd = e.filter(x=>!fkeys.includes(x.key))
      let dfiltered_ware = dfilterd.map(x=>x.warehouses).filter(x=>x.warehouses && x.warehouses.some(x=>parseInt(x.quantity) > 0 ? true : false))
      let efiltered_ware = efilterd.map(x=>x.warehouses).filter(x=>x.warehouses && x.warehouses.some(x=>parseInt(x.quantity) > 0 ? true : false))
      console.log(a)
      console.log(b)
      console.log(c)
      console.log(d)
      console.log(e)
      console.log(f)
      console.log(dfilterd)
      console.log(efilterd)
      console.log(dfiltered_ware)
      console.log(efiltered_ware)
      let skus = d.map(x=>x.sku)
      console.log(skus)
      for (let i = 0; i < skus.length; i++) {
        const sku = skus[i];
        let items = d.filter(x=>x.sku == sku)
        if(items.length && items.length > 1 && items.filter(x=>x.sku).length) {
          if( items.filter( y=> y.warehouses.filter(x=> parseInt(x.quantity) != 0).length ).length ) {
            let main = items.filter( y=> y.warehouses.filter(x=> parseInt(x.quantity) != 0).length )[0]
            console.log('active WH', main)

            console.log(a[main.key])
            console.log(b[main.key])
            console.log(c[main.key])
            console.log(e.filter(x=>x.key == main.key))
            if(!e.filter(x=>x.key == main.key).length) {
              console.log('NOTINLIVE')
            }
            console.log('laravel', f.data.filter(x=>x.key == main.key))
            if(!f.data.filter(x=>x.key == main.key).length) {
              console.log('laravel sku of active need key', f.data.filter(x=>x.sku == main.sku))
              if(f.data.filter(x=>x.sku == main.sku).length) {
                let mid = f.data.filter(x=>x.sku == main.sku)[0].id
                await axios.put(productApiUrl(`products/${mid}`), {key:main.key, id:mid}).then(x=>x.data)
              }
            }
            let delItems = items.filter(x=>x.key!=main.key)
            console.log(delItems)
            for (let k = 0; k < delItems.length; k++) {
              const item = delItems[k];
              console.log('kept key #', main.key, 'delete key =>', item.key)
              console.log(e.filter(x=>x.key == item.key).filter( y=> y.warehouses.filter(x=> parseInt(x.quantity) != 0).length))
              if(e.filter(x=>x.key == item.key).filter( y=> y.warehouses.filter(x=> parseInt(x.quantity) != 0).length).length) {
                console.log("LIVEACTIVE!!")
              }
              // await db.ref(`productsCore`).update({[item.key]:null})
              // await db.ref(`products`).update({[item.key]:null})
              // await db.ref(`productsCoreLite`).update({[item.key]:null})
              // await store.collection('products').doc(item.key).delete()
              // await store.collection('productsLive').doc(item.key).delete()
            }
          } else {
            let main = items[0]
            console.log('no active WH', main)
            console.log(a[main.key])
            console.log(b[main.key])
            console.log(c[main.key])
            console.log(e.filter(x=>x.key == main.key))
            if(!e.filter(x=>x.key == main.key).length) {
              console.log('NOTINLIVE')
            }
            console.log('laravel', f.data.filter(x=>x.key == main.key))
            if(!f.data.filter(x=>x.key == main.key).length) {
              console.log('laravel sku not active need key', f.data.filter(x=>x.sku == main.sku))
              if(f.data.filter(x=>x.sku == main.sku).length) {
                let mid = f.data.filter(x=>x.sku == main.sku)[0].id
                await axios.put(productApiUrl(`products/${mid}`), {key:main.key, id:mid}).then(x=>x.data)
              }
            }
            console.log(items)
            let delItems = items.filter(x=>x.key!=main.key)
            console.log('laravel com', f.data.filter(x=>delItems.map(x=>x.key).includes(x.key)))
            if(!f.data.filter(x=>x.key == main.key).length && f.data.filter(x=>delItems.map(x=>x.key).includes(x.key)).length) {
              console.log('|||||||||||THIS||||||||||||||')
            }
            console.log(delItems)
            for (let k = 0; k < delItems.length; k++) {
              const item = delItems[k];
              console.log('kept key #', main.key, 'delete key =>', item.key)
              console.log(e.filter(x=>x.key == item.key).filter( y=> y.warehouses.filter(x=> parseInt(x.quantity) != 0).length))
              if(e.filter(x=>x.key == item.key).filter( y=> y.warehouses.filter(x=> parseInt(x.quantity) != 0).length).length) {
                console.log("LIVEACTIVE!!")
              }
              // await db.ref(`productsCore`).update({[item.key]:null})
              // await db.ref(`products`).update({[item.key]:null})
              // await db.ref(`productsCoreLite`).update({[item.key]:null})
              // await store.collection('products').doc(item.key).delete()
              // await store.collection('productsLive').doc(item.key).delete()
            }
          }
        }
      }
    }
  },
  watch:{
  },
  computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
  async created(){
    await this.getWarehouses()
    this.setResourceName()
    await this.loadResource()
    await this.loadItems()

    
  },
  
}
</script>

<style>
.adminSwitch .v-input {
  margin-top:0 !important;
}
.adminSwitch .v-input__control {
  margin-bottom:0 !important;
}
.adminSwitch .v-label {
  font-size: 12px !important;
}
</style>